/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaInstagram, FaLinkedin, FaTwitter, FaFacebook } from 'react-icons/fa';
import logoLight from '../../assets/new_summit_logo/logo-light.png';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-content">
          {/* Logo and Socials Column */}
          <div className="footer-column">
            <a href="#home" className="footer-logo">
              <img src={logoLight} alt="Summit Logo" />
            </a>
            <div className="footer-divider"></div>
            <div className="footer-socials">
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaFacebook /></a>
              <a href="#"><FaLinkedin /></a>
              <a href="#"><FaTwitter /></a>
            </div>
          </div>

          {/* Quick Links Column */}
          <div className="footer-column">
            <h3>QUICK LINK</h3>
            <ul>
              <li><a href="#about">About</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#blog">Blog</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          {/* Resources Column */}
          <div className="footer-column">
            <h3>RESOURCES</h3>
            <ul>
              <li><a href="#">Authentication</a></li>
              <li><a href="#">System Status</a></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/data-deletions">Data Deletions</Link></li>
              <li><a href="#">Pricing</a></li>
            </ul>
          </div>

          {/* Developers Column */}
          <div className="footer-column">
            <h3>DEVELOPERS</h3>
            <ul>
              <li><a href="#">Documentation</a></li>
              <li><a href="#">Authentication</a></li>
              <li><a href="#">API Reference</a></li>
              <li><a href="#">Support</a></li>
              <li><a href="#">Open Source</a></li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="footer-bottom">
          <div className="copyright">
            © 2026. All rights reserved by Summit Visio
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
